import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
  Typography,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { UseBooleanActions } from "hooks/useBoolean";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { SkuUserAgreementInfo } from "services/KnowfullyAdminClient";

const styles = {
  title: {
    backgroundColor: "lightgrey",
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
  },
};

type UserAgreementPreviewBoxProps = {
  open: boolean;
  skuUserAgreement: SkuUserAgreementInfo;
  previewOpenActions: UseBooleanActions;
};

export function UserAgreementPreviewBox({
  open,
  skuUserAgreement,
  previewOpenActions,
}: UserAgreementPreviewBoxProps) {
  const { skuUserAgreementService } = useGlobalContext();
  const [file, setFile] = useState<string | null>(null);
  const { formatMessage: t } = useIntl();

  useEffect(() => {
    async function previewPdf() {
      if (open) {
        const response = await skuUserAgreementService.preview(
          skuUserAgreement.id
        );

        setFile(response.data!);
      }
    }

    previewPdf();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <>
      <Dialog open={open} disableEnforceFocus maxWidth="lg" fullWidth>
        <DialogContent style={{ height: "100vh" }}>
          <Typography sx={styles.title} variant="h2">
            <span style={{ margin: "10px" }}>
              {skuUserAgreement?.agreementName}
            </span>
          </Typography>
          {file != null ? (
            <iframe
              title="preview"
              src={file}
              style={{ width: "100%", height: "90%" }}
            />
          ) : (
            <LinearProgress color="secondary" />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setFile(null);
              previewOpenActions.setFalse();
            }}
          >
            {t({ id: "closeButton" })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
